import axiosInstance from "services/service-instance";
import noop from "lodash/noop";
import axios from "axios";
import Endpoint from "constants/endpoint";


export default {
    getCompanyVisibilityColumns: (companyId) =>
        axiosInstance.get(`underwriting/review/visibility/table-columns/${companyId}/`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getVisibilityData: (companyId, filters = null, data) =>
        axiosInstance.get(`underwriting/ledger-analysis/${companyId}/visibility-sheet/`, {
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                ...filters,
                ...data
            }
        }),
    getCaseId: (ledgerId) =>
        axiosInstance.get(`underwriting/return/case/ledger-analysis/${ledgerId}/`),
    getDateFilters: (companyId) =>
        axiosInstance.get(`/underwriting/ledger-master/distinct/date/list/${companyId}/`),
    approveLedgerAnalysis: (ledger_analysis_ids) =>
        axiosInstance.post("case/create/ledger-analysis/", {}, {
            params: {
                ledger_analysis_ids
            }
        }),
    getLedgerMasterTable: (sellerId, filters) =>
        axiosInstance.get("underwriting/ledger-master/update/", {
            params: {
                seller_id: sellerId,
                ...filters
            }
        }),
    updateLedgerMasterTable: (sellerId, data) =>
        axiosInstance.post("underwriting/ledger-master/update/", data, {
            params: {
                seller_id: sellerId
            }
        }),
    rejectLedgerAnalysis: (ledger_analysis_ids) =>
        axiosInstance.post("case/reject/ledger-analysis/", {}, {
            params: {
                ledger_analysis_ids
            }
        }),
    uploadBaseFile: (requestId, formData) =>
        axiosInstance.post(`company/base-file-upload/request/${requestId}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }),
    getRequestSyncData: (companyId) =>
        axiosInstance.get(`company/${companyId}/request-data/`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    downloadLedgers: (companyId, requestId) =>
        axiosInstance.get(`company/${companyId}/request-data/${requestId}`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    ledgersUpload: (companyId, formData) =>
        axiosInstance.post(`company/${companyId}/ledger/bulk-upload/`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }),
    generateDataSyncRequest: (company_id, body) =>
        axiosInstance.post(
            `company/${company_id}/request-data/`,
            { ...body, request_source: 1 },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ),
    getERPSoftware: () =>
        axiosInstance.get("/company/master-erp-software/", {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    tenorMasterList: () =>
        axiosInstance.get("/company/ledger-analysis-tenor/", {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    processRejectRequest: (id, data) =>
        axiosInstance.post(`/company/erp-data-request/${id}`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getSyncRequestCount: () =>
        axiosInstance.get("/company/erp-data-request/count", {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getAssociates: company_id =>
        axiosInstance.get(`/company/${company_id}/associates/`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getSyncRequest: (status, pageNo, search, paginate = true, pageSize = 300) =>
        axiosInstance.get("/company/request-data/", {
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                current_status: status,
                page: pageNo,
                search: search,
                paginate,
                page_size: pageSize,
            }
        }),
    getLendingPartner: () =>
        axiosInstance.get("/master/partner-bank/list/", {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    editFee: (companyId, data, id) =>
        axiosInstance.put(`/scheme/fee/${companyId}/lending-partner-seller-configuration/${id}/`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    addFee: (companyId, data) =>
        axiosInstance.post(`/scheme/fee/${companyId}/lending-partner-seller-configuration/`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getCompanyProfiles: (type, search, paginate = true) =>
        axiosInstance.get("/company/list/", {
            params: {
                paginate,
                page: paginate ? 1 : null,
                page_size: paginate ? 20 : null,
                type,
                search: search && Array.from(new Set(search.split(" "))).join(" ")
            }
        }),
    getFee: companyId =>
        axiosInstance.get(`/scheme/fee/${companyId}/lending-partner-seller-configuration/`, {
            params : {
                paginate : false,
            },
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getFeeMaster: () =>
        axiosInstance.get("/scheme/fee/master/", {
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                paginate: false
            }
        }),
    removeInvoice: data =>
        axiosInstance.post("/invoice/invoice-parse-buffer/inactive/", data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    finalSubmission: data =>
        axiosInstance.post("/invoice/maker-checker-final-submission/", data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getInvoiceCards: (start_date='', end_date='') =>
        axiosInstance.get(`/invoice/invoices-counter/?start_date=${start_date}&end_date=${end_date}`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getAllInvoiceJob: (search='', status, page, start_date='', end_date='', email='') =>
        axiosInstance.get(`/invoice/invoice-job-list/?search=${search}&paginate=true&status=${status}&page=${page}&page_size=20&start_date=${start_date}&end_date=${end_date}&email=${email}`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    updateInvoiceJob: (jobId, data, type) =>
        axiosInstance.post(`/invoice/invoice-job/bulk-update/${jobId}/${type}/`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getJobById: jobId =>
        axiosInstance.get(`/invoice/invoice-job/${jobId}/`),
    createInvoiceJob: data =>
        axiosInstance.post("/invoice/facility/invoice-job-create/", data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }),
    getCompanyLosProfile: companyId =>
        axiosInstance.get(`/company/${companyId}/`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    createCompanyLosProfile: data =>
        axiosInstance.post("/company/create/", data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    createCompanyProfile: data =>
        axiosInstance.post("/company/create/profile/", data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    updateCompanyLosProfile: (company_id, profile) =>
        axiosInstance.put(`/company/${company_id}/`, profile, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    updateCompanyLosDetail: (companyId, data) =>
        axiosInstance.post(`/company/detail/${companyId}/create/`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getCompanyLosDetail: companyId =>
        axiosInstance.get(`/company/detail/${companyId}/create/`),
    updateCompanyLosAttachments: noop,
    putCompanyLosAnnualTurnovers: (companyId, turnovers) =>
        axiosInstance.post(`/company/${companyId}/annual-turnover/create-list/`, turnovers, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getLosAnnualTurnovers: (companyId) =>
        axiosInstance.get(`/company/${companyId}/annual-turnover/create-list/`),
    putCompanyLosBankingFacilities: (companyId, data) =>
        axiosInstance.post(`/company/${companyId}/banking-facility/create-list/`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getLosBankingFacilities: (companyId) =>
        axiosInstance.get(`/company/${companyId}/banking-facility/create-list/`),

    getCompanyDocuments: (company_id , is_anchor=false) =>
        axiosInstance.get(`/company/${company_id}/documents/?paginate=false&is_anchor=${is_anchor}`),

    getCompanyLosProfiles: filters =>
        axiosInstance.get("/company/v2/list/", {
            params: {
                ...filters
            }
        }),
    createUpdateCompanyLosSpocUser: (company_id, spoc_user) =>
        axiosInstance.post(`/company/${company_id}/associates/`, spoc_user, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    putCompanyLosBrands: (companyId, brands) =>
        axiosInstance.post(`/company/${companyId}/channel-product-stat/`, brands, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getLosBrands: companyId =>
        axiosInstance.get(`/company/${companyId}/channel-product-stat/`),
    ifscLookup: str =>
        axiosInstance.get(`/master/bank-branch/?ifsc_code=${str}`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

    updateCompanyErps: (companyId, data) =>
        axiosInstance.post(`/company/erp-details/${companyId}/create-update-get/`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getLosErps: companyId =>
        axiosInstance.get(`/company/erp-details/${companyId}/create-update-get/`),
    locationLookup: ({
        city_id,
        city_name,
        district_id,
        district_name,
        state_id,
        state_name,
        country_id // Default Search Selection in India
    }) =>
        axiosInstance.get("/master/address/master/", {
            params: {
                city_id,
                city_name,
                district_id,
                district_name,
                state_id,
                state_name,
                country_id
            },
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getVPSMList: search =>
        axiosInstance.get("/user/sm-hierarchy/?role=VP Sales", {
            params: {
                search
            }
        }),
    getSMList: search =>
        axiosInstance.get("/user/sm-hierarchy/", {
            params: {
                search
            }
        }),
    getDSMList: search =>
        axiosInstance.get("/user/sm-hierarchy/?role=DSM", {
            params: {
                search
            }
        }),
    getDRMList: search =>
        axiosInstance.get("/user/sm-hierarchy/", {
            params: {
                search,
                role: "DRM"
            }
        }),
    getChannelProducts: search =>
        axiosInstance.get("/master/channel-product/list/", {
            params: {
                paginate: false,
                search
            }
        }),
    fetchFinancialYears: () =>
        axiosInstance.get("/master/financial-year/list/", {
            params: {
                paginate: false
            }
        }),
    getErpSoftwaresList: () =>
        axiosInstance.get("/master/erp-software/create-list/"),
    getProducts: () =>
        axiosInstance.get("/master/product/list/", {
            params: {
                paginate: false
            }
        }),
    updateCompanyLosSchemes: (company_id, schemes) =>
        axiosInstance.post(`/company/${company_id}/scheme/`, schemes, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getSchemeDetails: (companyId, options = {}) => {
        const config = {
            headers: {
                "Content-Type": "application/json"
            }
        };
        if (options.include_false === true) {
            config.params = { include_false: true };
        }
        return axiosInstance.get(`/company/${companyId}/scheme/list/`, config);
    },
    getSchemeListForSellerPricing: (companyId, { term_loan_type, anchor_id }) =>
        axiosInstance.get(`/company/${companyId}/scheme/list/`, {
            params: {
                term_loan_type,
                anchor_id
            },
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getLendingPartners: () =>
        axiosInstance.get("/master/partner-bank/list/", {
            params: {
                paginate: false
            }
        }),

    caseSearchList: (gstin) =>
        axiosInstance.get("/case/search/list/", {
            params: {
                gstin
            }
        }),
    getBankList: (str) =>
        axiosInstance.get("/master/bank/list/search/", {
            params: {
                search: str
            }
        }),

    updateAssociates: (companyId, associates) =>
        axiosInstance.post(`/company/associate/${companyId}/create-update/`, associates, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    updateBankAccounts: (company_id, bankAccounts) =>
        axiosInstance.post(
            `/company/${company_id}/bank-accounts/`,
            bankAccounts,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ),

    deleteErpDetails: (erp_id) =>
        axiosInstance.put(`/company/erp-details/${erp_id}/change-status/`, {
            is_active: false
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    deleteAnnualTurnover: (turnover_id) =>
        axiosInstance.put(`/company/annual-turnover/${turnover_id}/change-status/`, {
            is_active: false
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    deleteBrands: (brand_id) =>
        axiosInstance.put(`/company/channel-product-stat/${brand_id}/change-status/`, {
            is_active: false
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    deleteBankingFacility: (facilityId) =>
        axiosInstance.put(`/company/banking-facility/${facilityId}/change-status/`, {
            is_active: false
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

    getMarginSubvention: (tenorId) =>
        axiosInstance.get(`/scheme/${tenorId}/rff-disbursal-configuration/list/`),

    getCashback: () =>
        axiosInstance.get("/scheme/rff-cash-back-split-master/list/"),

    getTenorList: () =>
        axiosInstance.get("/scheme/tenor-master/list/"),

    getInterestConf: (id) =>
        axiosInstance.get(`/scheme/${id}/interest-configuration/list/`),

    getWithholdPercMasterList: () =>
        axiosInstance.get("/scheme/withhold-perc-master/list/"),
    getCompanySellerSchemeMappingList: (companyId) =>
        axiosInstance.get(`/company/${companyId}/seller-scheme-mapping/create-list/`),
    updateSellerSchemeMapping: (companyId, schemeMappingId, data) =>
        axiosInstance.put(`/company/${companyId}/seller-scheme-mapping/${schemeMappingId}/retrieve-update/`, data),
    createSellerScheme: (companyId, data) =>
        axiosInstance.post(`/company/${companyId}/seller-scheme/create-list/`, data),
    getCompanySellerSchemesList: (companyId) =>
        axiosInstance.get(`/company/${companyId}/seller-scheme/create-list/`),
    updateSellerScheme: (companyId, schemeId, data) =>
        axiosInstance.put(`/company/${companyId}/seller-scheme/${schemeId}/retrieve-update/`, data),
    getCompanyBrandsList: (companyId) =>
        axiosInstance.get(`/company/${companyId}/brand/create-list/`),
    createSellerSchemeMapping: (companyId, data) =>
        axiosInstance.post(`/company/${companyId}/seller-scheme-mapping/create-list/`, data),
    getAgreementDocumentMasterList: () =>
        axiosInstance.get("/master/aggreement-master/list/"),
    generateAgreementPdf: (data) =>
        axios.post("https://template.progcap.com/generate-agreement", data),
    generateCreditPdf: (data) =>
        axios.post("https://template.progcap.com/generate-credit-note", data),
    createCompanyAgreement: (companyId, data) =>
        axiosInstance.post(`/company/company-agreement/${companyId}/get-create/`, data),
    getCompanyAgreement: (companyId) =>
        axiosInstance.get(`/company/company-agreement/${companyId}/get-create/`),
    getAgreementDetail: (company_id) =>
        axiosInstance.get(`/company/${company_id}/agreement-detail/`),
    uploadPdf: (companyId, data) =>
        axiosInstance.post(`/company/company-agreement/${companyId}/file-upload/`, data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }),
    updateAddresses: (company_id, addresses) =>
        axiosInstance.post(`/company/${company_id}/addresses/`, addresses, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    migrateScheme: (company_id) =>
        axiosInstance.post(`/company/scheme-los-to-lms/${company_id}/`, {}, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    fetchDocumentMasterList: (companyId = null) =>
        axiosInstance.get("/document/master/list/", {
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                paginate: false,
                company_id : companyId
            }
        }),
    uploadCompanyLosAttachment: async (
        companyId,
        {
            file,
            documentId,
            remarks,
            mpa_approval_id
        }
    ) => {
        const formData = new FormData();
        formData.append("company", companyId);
        formData.append("document_id", documentId);
        formData.append("file", file);
        formData.append("file_name", file.name);
        formData.append("remarks", remarks);
        const { data, error } = await axiosInstance.post("/company/documents/create/", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        if (error) {
            return { error };
        }
        const response = await axiosInstance.put(`/company/${companyId}/document-master/${data.id}/detail/`, {
            ...data,
            document: documentId,
            file: data.file.id,
            remarks: remarks,
            mpa_approval_id
        });
        return response;
    },
    validateDocument: (company_id, document_id, data) =>
        axiosInstance.put(`/company/${company_id}/document-master/${document_id}/detail/`, data),
    inValidateDocument: (company_id, document_id, data) =>
        axiosInstance.put(`/company/${company_id}/document-master/${document_id}/detail/`, data),
    addRetailerMapping: (companyId, data) =>
        axiosInstance.post(`/company/${companyId}/bank-account/retailer-mapping/`, data),
    fetchRetailerMapping: (companyId) =>
        axiosInstance.get(`/company/${companyId}/bank-account/retailer-mapping/`),
    fetchCompanyVisibiltySheetData: (companyId) =>
        axiosInstance.get(`/company/${companyId}/erp-request-doc/download/`),
    downloadErpRequest: (companyId, docType) =>
        axiosInstance.get(`/company/${companyId}/erp-request-doc/download/${docType}/`),
    postRecognitionLetter: (data) =>
        axiosInstance.post("/company/agreement_reco_letter_leegality/", data),
    industryTypeList: (search) =>
        axiosInstance.get("/master/industry/list/", {
            params: {
                search
            }
        }),
    getDealers: (gstin) =>
        axiosInstance.get("invoice/dealer-code-list/", {
            params: {
                seller_gstin: gstin
            }
        }),
    deleteCompanyBank: (bankId) =>
        axiosInstance.put(`/company/bank-account/${bankId}/delete/`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    createNewScheme: (companyId, data) =>
        axiosInstance.post(`/company/${companyId}/scheme/create/`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

    makeSchemeDefault: (companyId, schemeId, data) =>
        axiosInstance.post(`company/${companyId}/scheme/${schemeId}/update/`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

    updateSchemeEndDate: (companyId, schemeId) =>
        axiosInstance.patch(`company/${companyId}/scheme/${schemeId}/end-date/update/`, {}, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

    submitSchemeList: (companyId, schemeId, data) =>
        axiosInstance.post(`company/${companyId}/scheme/${schemeId}/dwd-sp/add/`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

    submitDefaultSchemeList: (companyId, schemeId, data) =>
        axiosInstance.post(`company/${companyId}/scheme/${schemeId}/default-dwd-sp/update/`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

    getCasesAsSeller: (companyId, params, page, pageSize) =>
        axiosInstance.get(`company/${companyId}/case-as-seller/list/`, {
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                search: params,
                page: page,
                page_size: pageSize
            }
        }),

    getFlexibleParamValue: (companyId, schemeId) =>
        axiosInstance.get(`company/${companyId}/scheme/${schemeId}/dwd-sp/list/`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

    updateFlexibleParameter: (companyId, caseId, submitData, anchorId) =>
        axiosInstance.post(`company/${companyId}/case/${caseId}/update/`, submitData, {
            params: {
                anchor_id: anchorId
            },
            headers: {
                "Content-Type": "application/json"
            }
        }),

    updateDocumentStatus:(companyId , data) => 
        axiosInstance.put(`document/${companyId}/action_detail/change-status-update-signzy/`, data),

    getSellerWiseAnchorList: (gstin) =>
        axiosInstance.get(`invoice/seller-wise/anchor-list/`, {
            params: {
                seller_gstin: gstin  
            },
            headers: {
                "Content-Type": "application/json"
            }
        }),

    getBounceChargesMaster: () =>
        axiosInstance.get(Endpoint.getBounceChargesMaster, {
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                paginate: false
            }
        }),

    getPrePaymentChargeMaster: () =>
        axiosInstance.get(Endpoint.getPrePaymentChargesMaster, {
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                paginate: false
            }
        }),


    getBounceChargesData: (companyId) =>
        axiosInstance.get(Endpoint.bounceChargeData.replace(':companyId', companyId), {
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                paginate: false
            }
        }),

    getPrePaymentChargesData: (companyId) =>
        axiosInstance.get(Endpoint.prePaymentChargesData.replace(':companyId', companyId), {
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                paginate: false
            }
        }),

    addBounceCharge: (companyId, submitData) => 
        axiosInstance.post(Endpoint.bounceChargeData.replace(':companyId', companyId), submitData, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

    addPrePaymentCharge: (companyId, submitData) => 
        axiosInstance.post(Endpoint.prePaymentChargesData.replace(':companyId', companyId), submitData, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

    editPrePaymentCharge: (companyId, caseId, prePaymentId) => 
        axiosInstance.post(Endpoint.editPrePaymentCharges.replace(':companyId', companyId).replace(":caseId" , caseId), {
            "foreclosure_master" : prePaymentId.foreclosure_master
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

    editBounceCharges: (companyId, caseId, prePaymentId) => 
        axiosInstance.post(Endpoint.editBounceCharges.replace(':companyId', companyId).replace(":caseId" , caseId), {
            "bounce_charge" : prePaymentId.charge
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        }),  
    editCaseFee: (companyId, caseId, fee) =>
        axiosInstance.post(Endpoint.editCaseFee.replace(':companyId', companyId).replace(":caseId", caseId), {
            fee_seller_mapping_id: fee.fee_master
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getDBRiskControlDetail: companyId =>
        axiosInstance.get(`/company/db/mpa-details/`, {
            params: {
                'company_id': companyId
            },
            headers: {
                "Content-Type": "application/json"
            }
        }), 
    postDBRiskControlDetail: (body, requestType) =>{
        const typeReq = body?.mpa_approval_id === null ? "post" : requestType === 'edit_product_details' ? "patch" : "put";
        return(
        axiosInstance[typeReq](`/company/db/mpa-details/`, body ,{
            headers: {
                "Content-Type": "application/json"
            }
        }))}, 
    portfolioData: (case_id) => {
        return axiosInstance.get(`case/${case_id}/portfolio-view/`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
     getSubventionPercentage: (data) => {
        return axiosInstance.get(`case/subvention-calculator/`, {
             params: {
                ...data
            },
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    getSellerPricingDetails: (companyId) =>
        axiosInstance.get(Endpoint.sellerPricingDetails.replace(":companyId", companyId), {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    updateSellerPricingDetails: (companyId, data) =>
        axiosInstance.post(Endpoint.sellerPricingDetails.replace(":companyId", companyId), data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
};